"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppFeaturesDefinition = void 0;
exports.AppFeaturesDefinition = {
    forceLang: "string",
    location: "boolean",
    investmentsMap: "boolean",
    gallery: "boolean",
    showPrice: "boolean",
    logoMain: "boolean",
    isKiosk: "boolean",
    showScreenKeyboard: "boolean",
    closeFilter: "boolean",
    disableRightClick: "boolean",
    showFullscreenButton: "boolean",
    flatFileAsOverlay: "boolean",
    forceFlatFileAsOverlayOnMobile: "boolean",
    autoFullscreen: "boolean",
    emailToCustomerToken: "string",
    salesmanList: "custom",
    showFiltersBuilding: "boolean",
    useOldBuildingButtonsLayout: "boolean",
    hideNewBuildingButtonsLayout: "boolean",
    contactFormPhoneOptional: "boolean",
    contactFormFullNameOptional: "boolean",
    disableSold: "boolean",
    disableReserved: "boolean",
    defaultFlatListCards: "boolean",
    disableSendContactRequest: "boolean",
    disableViewFrameElementFlatCounter: "boolean",
    displayFlatsOrderAvailableReservedSold: "boolean",
    displayFlatsInAvailabilityOrderForEachSortColumn: "boolean",
    autoOpenOnMobile: "boolean",
    autoOpenOnMobileIfFlatIsSelected: "boolean",
    hideFlatsSold: "boolean",
    hideFlatsReserved: "boolean",
    disableAutoOpenOnMobileIfNotFirstView: "boolean",
    disableAutoOpenOnMobileIfCompareIsOpen: "boolean",
    disableCloseOpenFlatWhenSwitchingBuildings: "boolean",
    limitFlatsInCompare: "number",
    filtersUseButtonRooms: "boolean",
    autoscrollDesktop: "boolean",
    autoscrollOffset: "number",
    customDataLayerName: "string",
    showCustomDisclaimer: "boolean",
    disableCompare: "boolean",
    enableBottomTableCompare: "boolean",
    disableInquiryViewModeSwitch: "boolean",
    initFilterFlatStatus: "number",
    disableRightPanelOnDesktop: "boolean",
    shiftViewYAxisOnDesktop: "custom",
    hideFlatsSoldOnList: "boolean",
    hideFlatsReservedOnList: "boolean",
    hideFlatsCounter: "boolean",
    flatOutlinesAlwaysVisible: "boolean",
    hideViewportOutlinesTime: "number",
    disableFlatInfoCard: "boolean",
    concealableDesktopSidebar: "boolean",
    concealableDesktopSidebarDefaultHidden: "boolean",
    disableFlatCardsInForm: "boolean",
    concealableSidebarSecondaryMenu: "boolean",
    blockDigitsInFormName: "boolean",
    disableHideFilters: "boolean",
    currency: "string",
    showClearOverList: "boolean",
    hideFlatsViewModeSwitch: "boolean",
    hideSoldPrice: "boolean",
    hideReservedPrice: "boolean",
    disableTableHeader: "boolean",
    disableBuildingButton: "boolean",
    useCheckboxCompareButton: "boolean",
    estateTourIframeUrl: "string",
    startAppWithOpenPage: "number",
    forceHiddenBuildingSliderPlaceholder: "boolean",
    autoscrollIntoViewRatio: "number",
    autoscrollIntoViewTime: "number",
    disableShareButton: "boolean",
    useMobileInvestmentsMap: "boolean",
    enableInvestmentMapSidePanel: "boolean",
    newViewerMobileHeightMultiplier: "number",
    debounceAppModeChangeInMilliseconds: "number",
    debounceAppResizeInMillisecondsMobile: "number",
    debounceAppResizeInMillisecondsDesktop: "number",
    availableLanguages: "custom",
    customHideableTextFontWidthMultiplier: "number",
    disableMobileViewsSlider: "boolean",
    mobileHeaderAdditionalMargin: "number",
    customFormPhoneValidation: "boolean",
    customFormPhoneValidationRegex: "string",
    useDesktopMinimapLazyLoad: "boolean",
    forceKioskMinimapLazyLoad: "boolean",
    pushAPIGroupId: "string",
    pushAPIDataRefreshInSeconds: "number",
    startViewId: "number",
    customStyleId: "string",
    customStyleClassname: "string",
    openFlatWithFlatMediaOnDesktop: "string",
    changeFlatWithFlatMediaOnDesktop: "string",
    hide3DEstateLogo: "boolean",
    hideEmptyBuildingsOutlines: "boolean",
    desktopNewViewerMaxWidthToHeightRatio: "custom",
    preventWheelEventPropagation: "boolean",
    startMobileWithListOpened: "boolean",
    useExperimentalViewer: "boolean",
    hideCollectiveInquiryButtons: "boolean",
    hideCompareViewButtons: "boolean",
    disablePromoOutlineHighlight: "boolean",
    mobileViewerExpandedByDefault: "boolean",
    overrideFiltersInitState: "custom",
    disableMinimapAutoFit: "boolean",
    flipBuildingCardHeaderOrder: "boolean",
    heightToInitiateFiltersOpened: "number",
    hideMobileLogo: "boolean",
    usePreviousPrice: "boolean",
    overrideMobileZIndex: "number",
    initialViewIdOverride: "number",
    disableInquiryForReserved: "boolean",
    disableMobileLandscapeRotateOverlay: "boolean",
    useOldContactFormAPI: "boolean",
    customDollhouseProp: "string",
    customTourProp: "string",
    customExteriorTourProp: "string",
    disableGTM: "boolean",
    twoPercentCredit: "boolean",
    disableMobile3dView: "boolean",
    kioskShowCloseButton: "boolean",
    disablePromoFlatsAlwaysOnTop: "boolean",
    disableLocalStorage: "boolean",
    enableLocalStorage: "boolean",
    overrideFlatTourUrl: "string",
    filtersSliderDecimalSymbol: "string",
    compareCustomPropRoomCount: "string",
    disableUrlSearchParams: "boolean",
    highlightPromotion: "boolean",
};
//# sourceMappingURL=AppFeature.types.js.map